import { createStore, applyMiddleware, compose } from 'redux'
import { createEpicMiddleware } from 'redux-observable'

import createWssMiddleware from './lib/wss-mw'
import { signalingMiddleWare } from './lib/signaling-mw'
import { enhancer as routingEnhancer, middleware as routingMiddleware } from './lib/routing'
import { createWebRTCMiddleware } from './lib/webrtcConnection-mw'

import reducers from './reducers'
import { keyboardMouseEpic } from './epics'
import { fetchWssEndpointLogicMiddleware } from './logic/fetchWssEndpoint'
import { loginLogicMiddleware } from './logic/login'
import { whitelabelLogicMiddleware } from './logic/whitelabel'
import { appLogicMiddleware } from './logic/app'
import { mediaMiddleware } from './logic/media'
import { disconnectLogicMiddleware } from './logic/disconnect'
import { keyModifierHandlingLogicMiddleware } from './logic/keyModifier'
import { selectActiveMonitorLogicMiddleware } from './logic/selectActiveMonitor'
import { audioChatMiddleware } from './logic/audioChat'
import { clipboardLogicMiddleware } from './logic/clipboard'

function configureStore () {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const webrtcMiddleware = createWebRTCMiddleware()
  const epicMiddleware = createEpicMiddleware()

  const store = createStore(
    reducers,
    composeEnhancers(
      routingEnhancer,
      applyMiddleware(
        routingMiddleware,
        epicMiddleware,
        createWssMiddleware(),
        signalingMiddleWare(),
        webrtcMiddleware(),
        loginLogicMiddleware,
        whitelabelLogicMiddleware,
        fetchWssEndpointLogicMiddleware,
        disconnectLogicMiddleware,
        keyModifierHandlingLogicMiddleware,
        selectActiveMonitorLogicMiddleware,
        appLogicMiddleware,
        mediaMiddleware,
        audioChatMiddleware,
        clipboardLogicMiddleware
      )
    )
  )

  epicMiddleware.run(keyboardMouseEpic)

  return store
}

export default configureStore
